import React from 'react';

import './EssentialLinkGrid.css';
import EssentialLinkButton from './EssentialLinkButton';

import { ReactComponent as DiscordIcon } from '../assets/discord.svg';
import { ReactComponent as DevpostIcon } from '../assets/devpost.svg';
import { ReactComponent as GuideIcon } from '../assets/book.svg';
import { ReactComponent as MentorIcon } from '../assets/person.svg';



const EssentialLinkGrid: React.FC = () => {
  return (
    <div className="button-grid">
      <EssentialLinkButton 
        icon={<DiscordIcon />} 
        text="Discord"
        href="https://discord.gg/5ThDTademt" 
        className="discord"
      />
      <EssentialLinkButton 
        icon={<DevpostIcon />} 
        text="Devpost"
        href="https://uottahack8.devpost.com/" 
        className="devpost"
      />
      <EssentialLinkButton 
        icon={<GuideIcon />} 
        text="Hacker Guide" 
        href="/guide" 
        className="guide"
        internal={true}
      />
      <EssentialLinkButton 
        icon={<MentorIcon />} 
        text="Help" 
        href="https://discord.com/channels/1207408455971905636/1452868402812162211" 
        className="mentor"
      />
    </div>
  );
};

export default EssentialLinkGrid;